<template>
  <div class="queryTicket">
    <input placeholder="请输入游客证件号" v-model="inputText" />
    <div @click="query()">确定</div>
  </div>
</template>
<script>
import order from '@/api/order';
export default {
  data() {
    return {
      inputText: '',
    };
  },
  methods: {
    async query() {
      const getUserTickets = await order.userGetTickets({
        id: '123456',
      });
    },
  },
};
</script>
<style scoped lang="less">
.queryTicket {
  width: 100%;
  background-color: #f8f8f8;
}
</style>
